export default function ImportStatusBadge({ status }) {
  const key = String(status || "").toLowerCase();
  const cls = key === "create"
    ? "bg-emerald-100 text-emerald-700"
    : key === "exact_duplicate"
      ? "bg-amber-100 text-amber-700"
      : key === "possible_duplicate"
        ? "bg-orange-100 text-orange-700"
        : "bg-rose-100 text-rose-700";

  const label = key === "create"
    ? "Nieuw"
    : key === "exact_duplicate"
      ? "Exact dubbel"
      : key === "possible_duplicate"
        ? "Mogelijk dubbel"
        : "Fout";

  return (
    <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
}
